'use strict';

var app = require('mag-app'),
    deviceApi;

if ( PLATFORM === 'BROWSER' || (PLATFORM === 'MAG' && DEVELOP) ) {
    deviceApi = require('./platforms/browser/device.api');
} else if ( PLATFORM === 'SMARTTV' ) {
    deviceApi = require('./platforms/smarttv/device.api');
} else if ( PLATFORM === 'TIZEN' ) {
    deviceApi = require('./platforms/tizen/device.api');
}


if ( PLATFORM === 'WEBOS' ) {
    deviceApi = require('./platforms/webos/device.api');
}


if ( app.query.mac ) {
    // metadata in GET params
    deviceApi = {
        network: {
            mac: function (callback) {
                callback(null, app.query.mac);
            }
        },
        model: function ( callback ) {
            callback(null, 'SmartTV');
        },
        metric1: function ( callback ) {
            callback(null, app.query.meta1);
        },
        metric2: function ( callback ) {
            callback(null, app.query.meta2);
        },
        metric3: function ( callback ) {
            callback(null, app.query.meta3);
        },
        clientType: function (callback) {
            callback(null, app.query.clientType);
        }
    };
}

module.exports = deviceApi;
